var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7705 25.33C15.9711 25.33 15.2195 25.165 14.5155 24.835C13.8188 24.505 13.2175 24.0467 12.7115 23.46C12.2055 22.8733 11.8425 22.1913 11.6225 21.414L14.5045 20.644C14.5998 21.018 14.7685 21.3407 15.0105 21.612C15.2598 21.8833 15.5458 22.096 15.8685 22.25C16.1985 22.3967 16.5358 22.47 16.8805 22.47C17.3351 22.47 17.7495 22.36 18.1235 22.14C18.5048 21.92 18.8055 21.623 19.0255 21.249C19.2528 20.875 19.3665 20.4607 19.3665 20.006C19.3665 19.5513 19.2528 19.137 19.0255 18.763C18.8055 18.389 18.5048 18.092 18.1235 17.872C17.7495 17.652 17.3351 17.542 16.8805 17.542C16.3231 17.542 15.8685 17.6373 15.5165 17.828C15.1645 18.0113 14.9005 18.1873 14.7245 18.356L12.1945 17.586L12.6785 9.16H21.3245V11.954H14.3285L15.3845 10.964L15.0545 16.398L14.5485 15.782C14.9445 15.4593 15.3955 15.2247 15.9015 15.078C16.4075 14.9313 16.8805 14.858 17.3205 14.858C18.3178 14.858 19.1941 15.0817 19.9495 15.529C20.7121 15.969 21.3061 16.5777 21.7315 17.355C22.1641 18.125 22.3805 19.0087 22.3805 20.006C22.3805 21.0033 22.1201 21.9053 21.5995 22.712C21.0788 23.5113 20.3931 24.1493 19.5425 24.626C18.6918 25.0953 17.7678 25.33 16.7705 25.33Z",
    fill: "#2B65CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 39C24.1525 39 17 46.1525 17 47.75C17 46.1525 9.84751 39 8.25 39C9.84751 39 17 31.8475 17 30.25C17 31.8475 24.1525 39 25.75 39Z",
    fill: "#2B65CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.75 59C49.8745 59 37 71.8745 37 74.75C37 71.8745 24.1255 59 21.25 59C24.1255 59 37 46.1255 37 43.25C37 46.1255 49.8745 59 52.75 59Z",
    fill: "#2B65CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5D);
export default __webpack_public_path__ + "static/media/5d.04f5d2ce499fb05a71c534afde269cad.svg";
export { ForwardRef as ReactComponent };